module.exports = __webpack_public_path__ + "static/media/logo.85714e0f.png";